// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"565":"07f56d67","608":"95c1cb49"}[chunkId] + ".css";
};